import { Loader2 } from 'lucide-react';

export const PremiumLoadingOverlay = () => {
  return (
    <div className="absolute inset-0 z-10 rounded-lg backdrop-blur-sm bg-background/60 flex items-center justify-center">
      <Loader2 className="w-8 h-8 animate-spin text-primary" />
    </div>
  );
};
